import { Default } from './default.js';

export class Exposition extends Default {
  constructor(opt) {
    super(opt);
    this.slug = 'exposition';
  }
}
